module.exports = __webpack_public_path__ + "resource/img/ico.7b383d89.png";